import React, { useState } from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import Inicial from "./pages/Inicial";
import Detalhes from "./pages/Detalhes";
import Menu from "./components/Menu/Menu";
import Pesquisa from "./components/Pesquisa/Pesquisa";
import Pesquisado from "./components/Pesquisado/Pesquisado";
import Rodape from "./components/Rodape/Rodape";
import RV from "./pages/RV";
import RA from "./pages/RA";
import Video360i from "./pages/V360i";
import Video360 from "./pages/V360";
import TrilhaNavegacao from "./components/TrilhaNavegacao/TrilhaNavegacao";
import dados from "./data/projetosGerais.json";
import "./styles.css"

function App() {
  const [textoPesquisa, setTextoPesquisa] = useState("");
  const [resultados, setResultados] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();



  function aplicarPesquisa(texto) {
    setTextoPesquisa(texto);

    const textoLimpo = texto.trim();

    /* 🔹 Atualiza a URL com query string */
    if (textoLimpo === "") {
      navigate("/", { replace: true });
      setResultados([]);
      return;
    }

    navigate("/?q=" + encodeURIComponent(textoLimpo), { replace: true });

    const filtrados = dados.filter(function (item) {
      return (
        item.titulo.toLowerCase().includes(textoLimpo.toLowerCase()) ||
        item.descricao.toLowerCase().includes(textoLimpo.toLowerCase()) ||
        item.info.toLowerCase().includes(textoLimpo.toLowerCase())
      );
    });

    setResultados(filtrados);
  }

  /* 🔹 Limpa pesquisa e retorna ao estado inicial */
  function limparPesquisa() {
    setTextoPesquisa("");
    setResultados([]);
    navigate("/", { replace: true });
  }

  function irParaCategoria(rota) {
    setTextoPesquisa("");
    setResultados([]);
    navigate(rota);
  }


  /* ========================= TrilhaNavegacao ========================= */

  /* 🔹 Detecta rota atual */
  const caminhoAtual = location.pathname;

  /* 🔹 Verifica se está na Home */
  const estaNaHome = caminhoAtual === "/";

  /* 🔹 Busca só existe na Home */
  const possuiQueryBusca =
    estaNaHome && location.search.includes("?q=");

  /* 🔹 Página de detalhes */
  const estaNosDetalhes = caminhoAtual.startsWith("/projeto");

  /* 🔹 Categorias */
  const rotasCategorias = ["/rv", "/ra", "/video360", "/video360i"];

  const estaEmCategoria = rotasCategorias.some(function (rota) {
    return caminhoAtual.startsWith(rota);
  });

  /* 🔹 Regra final da trilha */
  const mostrarTrilha =
    estaNosDetalhes ||
    possuiQueryBusca ||
    estaEmCategoria;

  return (
    <>

      {/* 🔝 ELEMENTOS FIXOS */}
      <Menu
        texto={textoPesquisa}
        onTextoChange={setTextoPesquisa}
        onPesquisar={aplicarPesquisa}
        aoIrHome={limparPesquisa}
      />

      <div className="busca-global">
        <div className="container">
          <div
            className={
              mostrarTrilha
                ? "busca-container dupla"
                : "busca-container centralizada"
            }
          >
            {mostrarTrilha ? (
              <div className="area-trilha">
                <TrilhaNavegacao
                  aoIrHome={limparPesquisa}
                  aoIrCategoria={irParaCategoria}
                />
              </div>
            ) : null}

            <Pesquisa
              texto={textoPesquisa}
              onTextoChange={setTextoPesquisa}
              onPesquisar={aplicarPesquisa}
            />
          </div>
        </div>
      </div>

      <div className="conteudo-principal container">
        {/* 🔀 ROTAS */}
        <Routes>
          <Route
            path="/"
            element={
              possuiQueryBusca ? (
                <Pesquisado
                  resultados={resultados}
                  limpar={limparPesquisa}
                />
              ) : (
                <Inicial dados={dados} />
              )
            }
          />

          <Route path="/projeto/:id" element={<Detalhes />} />
          <Route path="/rv" element={<RV />} />
          <Route path="/ra" element={<RA />} />
          <Route path="/video360" element={<Video360 />} />
          <Route path="/video360i" element={<Video360i />} />
        </Routes>
      </div>

      <Rodape />
    </>
  );
}

export default App;
